// Translations for the new navigation structure (header + footer), all 7 supported languages.
export const NAVX = {
  en: {
    travelToChina: "Travel to China", chinaJourneys: "China Journeys", educationTrips: "Education Trips", medicalTrips: "Medical Trips",
    chinaExperiences: "China Experiences", visaAssistance: "Visa Assistance", planMyTrip: "Plan My Trip",
    bookTravel: "Book Travel", globalFlights: "Global Flights", globalHotels: "Global Hotels",
    comingSoon: "Coming Soon", rail: "Rail", bus: "Bus", businessTravel: "Business Travel",
    signIn: "Sign In", myPortal: "My Portal", myJourneys: "My Journeys", admin: "Admin", live: "Live",
    company: "Company", exploreChina: "Explore China", travelSupport: "Travel Support",
    business: "Business", blog: "Blog", b2bLogin: "B2B / Partner Login",
  },
  zh: {
    travelToChina: "前往中国", chinaJourneys: "中国精选行程", educationTrips: "教育研学", medicalTrips: "医疗之旅",
    chinaExperiences: "中国体验", visaAssistance: "签证协助", planMyTrip: "定制行程",
    bookTravel: "预订出行", globalFlights: "全球机票", globalHotels: "全球酒店",
    comingSoon: "即将上线", rail: "铁路", bus: "巴士", businessTravel: "商务差旅",
    signIn: "登录", myPortal: "我的门户", myJourneys: "我的行程", admin: "管理后台", live: "实时",
    company: "公司", exploreChina: "探索中国", travelSupport: "出行支持",
    business: "商务", blog: "博客", b2bLogin: "B2B / 合作伙伴登录",
  },
  ar: {
    travelToChina: "السفر إلى الصين", chinaJourneys: "رحلات الصين المنسقة", educationTrips: "رحلات تعليمية", medicalTrips: "رحلات علاجية",
    chinaExperiences: "تجارب الصين", visaAssistance: "مساعدة التأشيرات", planMyTrip: "خطط رحلتي",
    bookTravel: "حجز السفر", globalFlights: "رحلات طيران عالمية", globalHotels: "فنادق عالمية",
    comingSoon: "قريباً", rail: "القطارات", bus: "الحافلات", businessTravel: "سفر الأعمال",
    signIn: "تسجيل الدخول", myPortal: "بوابتي", myJourneys: "رحلاتي", admin: "الإدارة", live: "مباشر",
    company: "الشركة", exploreChina: "اكتشف الصين", travelSupport: "دعم السفر",
    business: "الأعمال", blog: "المدونة", b2bLogin: "دخول الشركاء B2B",
  },
  ru: {
    travelToChina: "Путешествие в Китай", chinaJourneys: "Путешествия по Китаю", educationTrips: "Образовательные поездки", medicalTrips: "Медицинские поездки",
    chinaExperiences: "Впечатления Китая", visaAssistance: "Визовая поддержка", planMyTrip: "Спланировать поездку",
    bookTravel: "Бронирование", globalFlights: "Глобальные авиарейсы", globalHotels: "Отели по всему миру",
    comingSoon: "Скоро", rail: "Ж/Д", bus: "Автобус", businessTravel: "Деловые поездки",
    signIn: "Войти", myPortal: "Мой портал", myJourneys: "Мои поездки", admin: "Админ", live: "Live",
    company: "Компания", exploreChina: "Откройте Китай", travelSupport: "Поддержка путешествий",
    business: "Бизнес", blog: "Блог", b2bLogin: "B2B / Вход для партнёров",
  },
  fr: {
    travelToChina: "Voyager en Chine", chinaJourneys: "Circuits en Chine", educationTrips: "Voyages éducatifs", medicalTrips: "Voyages médicaux",
    chinaExperiences: "Expériences en Chine", visaAssistance: "Assistance visa", planMyTrip: "Planifier mon voyage",
    bookTravel: "Réserver un voyage", globalFlights: "Vols internationaux", globalHotels: "Hôtels internationaux",
    comingSoon: "Bientôt disponible", rail: "Train", bus: "Bus", businessTravel: "Voyages d'affaires",
    signIn: "Se connecter", myPortal: "Mon portail", myJourneys: "Mes voyages", admin: "Admin", live: "En direct",
    company: "Entreprise", exploreChina: "Explorer la Chine", travelSupport: "Assistance voyage",
    business: "Affaires", blog: "Blog", b2bLogin: "Connexion B2B / Partenaires",
  },
  es: {
    travelToChina: "Viajar a China", chinaJourneys: "Viajes por China", educationTrips: "Viajes educativos", medicalTrips: "Viajes médicos",
    chinaExperiences: "Experiencias en China", visaAssistance: "Asistencia de visado", planMyTrip: "Planificar mi viaje",
    bookTravel: "Reservar viaje", globalFlights: "Vuelos globales", globalHotels: "Hoteles globales",
    comingSoon: "Próximamente", rail: "Tren", bus: "Autobús", businessTravel: "Viajes de negocios",
    signIn: "Iniciar sesión", myPortal: "Mi portal", myJourneys: "Mis viajes", admin: "Admin", live: "En vivo",
    company: "Empresa", exploreChina: "Explora China", travelSupport: "Soporte de viaje",
    business: "Negocios", blog: "Blog", b2bLogin: "Acceso B2B / Socios",
  },
  de: {
    travelToChina: "Reisen nach China", chinaJourneys: "China-Reisen", educationTrips: "Bildungsreisen", medicalTrips: "Medizinreisen",
    chinaExperiences: "China-Erlebnisse", visaAssistance: "Visa-Unterstützung", planMyTrip: "Reise planen",
    bookTravel: "Reisen buchen", globalFlights: "Weltweite Flüge", globalHotels: "Weltweite Hotels",
    comingSoon: "Demnächst", rail: "Bahn", bus: "Bus", businessTravel: "Geschäftsreisen",
    signIn: "Anmelden", myPortal: "Mein Portal", myJourneys: "Meine Reisen", admin: "Admin", live: "Live",
    company: "Unternehmen", exploreChina: "China entdecken", travelSupport: "Reise-Support",
    business: "Business", blog: "Blog", b2bLogin: "B2B / Partner-Login",
  },
};

export const navx = (lang) => NAVX[lang] || NAVX.en;
